export default "__VITE_ASSET__7b4b7dfa__"